import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteRegionalActions } from "store/ducks/settings/regional";

export function* deleteRegionalRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/regional/${id}`,
    );

    const { data } = responseBody;
    yield put(DeleteRegionalActions.success(data));
    notify("success", "Regional deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteRegionalActions.failure(errorMessage));
  }
}
